import * as a from "./actions";

const INITIAL_STATE = {
  get: {
    success: false,
    loading: false,
    error: false
  },
  post: {
    success: false,
    loading: false,
    error: false
  }
};

export function assures(state = INITIAL_STATE, action) {
  switch (action.type) {
    case a.GET_CHOIX_QUESTIONS_MEDICALES.REQUEST:
      return {
        ...state,
        get: {
          success: false,
          loading: true,
          error: false
        }
      };
    case a.GET_CHOIX_QUESTIONS_MEDICALES.SUCCESS:
      return {
        ...state,
        get: {
          success: true,
          loading: false,
          error: false
        },
        assures: action.payload
      };
    case a.GET_CHOIX_QUESTIONS_MEDICALES.FAILURE:
      return {
        ...state,
        get: {
          success: false,
          error: true,
          loading: false
        }
      };
    case a.POST_CHOIX_QUESTIONS_MEDICALES.REQUEST:
      return {
        ...state,
        post: {
          success: false,
          loading: true,
          error: false
        }
      };
    case a.POST_CHOIX_QUESTIONS_MEDICALES.SUCCESS:
      return {
        ...state,
        post: {
          success: true,
          loading: false,
          error: false
        },
        assures: action.payload
      };
    case a.POST_CHOIX_QUESTIONS_MEDICALES.FAILURE:
      return {
        ...state,
        post: {
          success: false,
          error: true,
          loading: false
        }
      };
    default:
      return state;
  }
}

export default assures;
